// extracted by mini-css-extract-plugin
export default {"icon":"TimesCircle_icon__WqK8P"};